








































import { Component, Vue } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import ClassStepperForm from "@/components/ClassStepperForm/ClassStepperForm.vue";

import { Action } from "vuex-class";
import { AxiosError, AxiosPromise } from "axios";
import { IClassPayload } from "@/models/interfaces/classes";

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    BasePopup,
    BaseButton,

    ClassStepperForm
  }
})
export default class AddClassView extends Vue {
  @Action("classes/createClass")
  private createClass!: (payload: {
    schoolId: string;
    data: IClassPayload;
  }) => AxiosPromise;

  @Action("classes/assignStudentsToClass")
  private assignStudentsToClass!: (data: {
    userIds: string[];
    classId: string;
  }) => AxiosPromise;

  @Action("classes/assignTeachersToClass")
  private assignTeachersToClass!: (data: {
    userIds: string[];
    classId: string;
  }) => AxiosPromise;

  public $refs!: {
    form: HTMLDivElement & {
      onPrev: () => void;
    };
  };

  private currentStepIndex = 0;

  private creatingClassPending = false;

  private popupMessage = "";
  private showPopup = false;
  private popupTimeout = 0;

  private setIndex(index: number) {
    this.currentStepIndex = index;
  }

  private onPrev() {
    this.$refs.form.onPrev();
  }

  private onPopupSubmit() {
    this.showPopup = false;

    this.popupTimeout = window.setTimeout(() => {
      this.$router.push("/classes");
    }, 500);
  }

  private async submit(payload: {
    class: {
      schoolId: string;
      data: IClassPayload;
    };
    students: string[];
    teachers: string[];
  }) {
    this.creatingClassPending = true;

    try {
      const {
        data: { classId }
      } = await this.createClass(payload.class);

      await Promise.all([
        this.assignStudentsToClass({
          userIds: payload.students,
          classId
        }),
        this.assignTeachersToClass({
          userIds: payload.teachers,
          classId
        })
      ]);
      this.creatingClassPending = false;

      this.popupMessage = this.$t("views.classes.messages.create") as string;
      this.showPopup = true;
    } catch (error) {
      const { response } = error;

      if (!response || response.status !== 403) {
        this.creatingClassPending = false;
        this.popupMessage = this.$t("views.classes.errors.create") as string;
        this.showPopup = true;
      }
    }
  }

  public destroyed() {
    window.clearTimeout(this.popupTimeout);
  }
}
